import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses, problemCards, volumes } from '../data/content';
import { HeroSection } from '../components/HeroSection';
import { ProblemCard } from '../components/ProblemCard';
import { ProductIntro } from '../components/ProductIntro';
import { VolumeCard } from '../components/VolumeCard';
import { ProductPreviewGallery } from '../components/ProductPreviewGallery';
import { BonusCard } from '../components/BonusCard';
import { BenefitsGrid } from '../components/BenefitsGrid';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQAccordion } from '../components/FAQAccordion';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { PurchasePopup } from '../components/PurchasePopup';
type LandingPageProps = {
  guaranteeEnabled: boolean;
  testimonialsEnabled: boolean;
  bonusReferencePricesEnabled: boolean;
  salesPopupEnabled: boolean;
};
export function LandingPage({
  guaranteeEnabled,
  testimonialsEnabled,
  bonusReferencePricesEnabled,
  salesPopupEnabled
}: LandingPageProps) {
  return <div className="min-h-screen w-full bg-outer font-body" data-id="element-173" data-mp="38hseerpqso2a">
      <main className="mx-auto w-full max-w-[768px] overflow-hidden bg-white" data-id="element-174" data-mp="3db3n6ye47ewu">
        <HeroSection guaranteeEnabled={guaranteeEnabled} data-id="element-175" data-mp="3ia7utkle54l2" />

        <section className="space-y-2.5 bg-[#F7FAFC] px-4 py-4 md:px-12" data-id="element-176" data-mp="3ibrg5plwm5tp">
          {problemCards.map(c => <ProblemCard key={c.title} {...c} data-id="element-177" data-mp="3racs31wvemli" />)}
        </section>

        <ProductIntro data-id="element-178" data-mp="3r8a4spn3r7kh" />

        <section className="bg-white px-4 py-6 md:px-12 md:py-7" data-id="element-179" data-mp="3jv6a9419ms">
          <h2 className="text-center font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-navy md:text-[32px]" data-id="element-180" data-mp="1pfpbgly9q3">
            What's Included
          </h2>
          <div className="mt-3 space-y-2.5" data-id="element-181" data-mp="21vf0870v2fw1">
            {volumes.map(v => <VolumeCard key={v.number} label={`Volume ${v.number}`} title={v.title} points={v.points} finalLine={v.finalLine} data-id="element-182" data-mp="356m4m2n0n51p" />)}
          </div>
        </section>

        <ProductPreviewGallery data-id="element-183" data-mp="3e70oqyo8ue3m" />

        <section className="bg-navy px-4 py-6 md:px-12 md:py-7" data-id="element-184" data-mp="3e823bd4gxiq3">
          <h2 className="flex items-center justify-center gap-2 text-center font-heading text-[21px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-gold md:text-[32px]" data-id="element-185" data-mp="396mhvjydpa76">
            <GiftIcon className="h-6 w-6 shrink-0 md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-186" data-mp="3j6dafg3dpf4m" />
            Includes 4 free professional bonuses
          </h2>
          <div className="mt-3 space-y-2.5" data-id="element-187" data-mp="tytkt7z3gq2">
            {bonuses.map(b => <BonusCard key={b.number} {...b} showReferencePrice={bonusReferencePricesEnabled} data-id="element-188" data-mp="3swgfienryjjb" />)}
          </div>
        </section>

        <BenefitsGrid data-id="element-189" data-mp="5r77uiq030m1" />
        <OfferSection showReferencePrices={bonusReferencePricesEnabled} guaranteeEnabled={guaranteeEnabled} data-id="element-190" data-mp="5s0ab7hxf3yd" />
        {guaranteeEnabled && <GuaranteeSection data-id="element-191" data-mp="pdijsrs9aq06" />}
        {testimonialsEnabled && <TestimonialsSection data-id="element-192" data-mp="ucdb6i4ahmvw" />}
        <FAQAccordion data-id="element-193" data-mp="ubbr5o5apq21" />
        <FinalCTA guaranteeEnabled={guaranteeEnabled} data-id="element-194" data-mp="u9r56mx1rffs" />
        <Footer data-id="element-195" data-mp="fdjdz2n81dr0" />
      </main>
      {salesPopupEnabled && <PurchasePopup data-id="element-196" data-mp="fgxd820l96u8" />}
    </div>;
}